import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import api from "../api/axiosInstance";
import { uploadToCloudinary } from "../utils/cloudinaryUpload";
import { useEffect, useState } from "react";

const CivilianForm = ({ category }) => {
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [otp, setOtp] = useState("");
  const [isVerifying, setIsVerifying] = useState(false);
  const [isSendingOtp, setIsSendingOtp] = useState(false);
  const [formData, setFormData] = useState(null);
  const [cooldownSeconds, setCooldownSeconds] = useState(0); // Add this line
  const [cooldownInterval, setCooldownInterval] = useState(null); // Add this line

  // Form validation schema
  const validationSchema = Yup.object().shape({
    membershipType: Yup.string()
      .required("Membership type is required")
      .notOneOf(["Select Type of Membership"], "Membership type is required"),
    firstName: Yup.string().required("First Name is required"),
    lastName: Yup.string().required("Last Name is required"),
    fatherOrHusbandName: Yup.string().required(
      "Father's/Husband's Name is required"
    ),
    nationality: Yup.string().required("Nationality is required"),
    occupation: Yup.string().required("Occupation is required"),
    bloodGroup: Yup.string().required("Blood Group is required"),
    mobile: Yup.string()
      .required("Mobile number is required")
      .matches(/^[0-9]+$/, "Must be only digits")
      .min(11, "Must be at least 11 digits"),
    officialAddress: Yup.string().required("Official Address is required"),
    presentAddress: Yup.string().required("Present Address is required"),
    permanentAddress: Yup.string().required("Permanent Address is required"),
    monthlyIncome: Yup.number().required("Monthly Income is required"),
    incomeTaxReturn: Yup.string().required("Tax return document is required"),

    nationalId: Yup.string().required("National ID is required"),
    nidName: Yup.string().required("NID Name is required"),
    nidFathersName: Yup.string().required(
      "Father's Name (from NID) is required"
    ),
    nidMothersName: Yup.string().required(
      "Mother's Name (from NID) is required"
    ),
    nidDob: Yup.date().required("Date of Birth (from NID) is required"),
    nidCopy: Yup.string().required("NID image is required"),
    photo:
      Yup.string()
      .required("Photo is required"),

    proposerName: Yup.string().required("Proposer name is required"),
    proposerMembership: Yup.string().required("Proposer name is required"),
    proposerClubName: Yup.string().required(
      "Proposer club name info is required"
    ),
    proposerSignature: Yup.string().required("Proposer signature is required"),
    email: Yup.string().email("Invalid email").required("Email is required"),
  });

  const navigate = useNavigate();
  // const [message, setMessage] = useState("");

  // Formik setup
  const formik = useFormik({
    initialValues: {
      membershipType: "Select Type of Membership",

      firstName: "",
      lastName: "",
      fatherOrHusbandName: "",
      nationality: "",
      occupation: "",
      bloodGroup: "",
      mobile: "",
      officialAddress: "",
      presentAddress: "",
      permanentAddress: "",
      monthlyIncome: "",
      incomeTaxReturn: "",
      nationalId: "",
      nidName: "",
      nidFathersName: "",
      nidMothersName: "",
      nidDob: "",
      nidCopy: "",
      spouseName: "",
      spouseOccupation: "",
      spouseAddress: "",

      children: [],
      golfClubMembership: "",
      officialHandicap: "",

      photo: "",

      proposerName: "",
      proposerMembership: "",
      proposerClubName: "",
      proposerSignature: "",
      email: "",
    },
    validationSchema,
    // onSubmit: async (values, { setSubmitting }) => {
    //   console.log("Form submission started");
    //   console.log("Form values:", values);
    //   try {
    //     setSubmitting(true);

    //     // Filter out empty children
    //     const filteredChildren = values.children.filter(
    //       (child) => child.name.trim() !== ""
    //     );

    //     const submissionData = {
    //       ...values,
    //       category: category,
    //       children: filteredChildren.length > 0 ? filteredChildren : undefined,
    //     };

    //     // FIX: Correct axios response handling
    //     const response = await api.post(
    //       "/registration/membership",
    //       submissionData
    //     );

    //     // Check for successful response
    //     if (response.status === 201) {
    //       toast.success(
    //         "Registration submitted! Please check your email for verification."
    //       );

    //       navigate("/verify-email", {
    //         state: {
    //           email: values.email,
    //         },
    //       });

    //       // setMessage(response.data.message);
    //       console.log(response.data);
    //     } else {
    //       toast.error(response.data.message || "Registration failed");
    //     }
    //   } catch (error) {
    //     console.error("Registration error:", error);

    //     if (error.response) {
    //       // Server responded with error status
    //       toast.error(
    //         error.response.data?.message ||
    //           "An error occurred during registration. Please try again."
    //       );
    //     } else if (error.request) {
    //       // Request was made but no response received
    //       toast.error("Network error. Please check your connection.");
    //     } else {
    //       // Something else happened
    //       toast.error("An unexpected error occurred.");
    //     }
    //   } finally {
    //     setSubmitting(false);
    //   }
    // },
    onSubmit: async (values, { setSubmitting }) => {
      console.log("Form submission started");
      console.log("Form values:", values);
      try {
        setSubmitting(true);

        // First check if we can send OTP (cooldown and existing registration)
        try {
          const cooldownResponse = await api.get("/verification/cooldown", {
            params: { email: values.email },
          });

          if (!cooldownResponse.data.canSendOtp) {
            const seconds = cooldownResponse.data.cooldownSeconds;
            setCooldownSeconds(seconds);
            startCooldownTimer(seconds);
            toast.error(
              `Please wait ${seconds} seconds before requesting another code`
            );
            return;
          }
        } catch (cooldownError) {
          console.log(
            "Cooldown check failed, proceeding anyway:",
            cooldownError
          );
        }

        // Store form data for later submission
        setFormData(values);

        // Send OTP to email
        setIsSendingOtp(true);
        await api.post("/verification/send-otp", null, {
          params: { email: values.email },
        });

        toast.success("Verification code sent to your email");
        setShowOtpModal(true);
      } catch (error) {
        console.error("Error sending OTP:", error);
        console.error("Full error object:", error);
        console.error("Error response:", error.response);

        // Handle specific error messages from backend
        // if (error.response?.data) {
        //   toast.error(error.response.data.message);
        // } else if (error.response?.status === 409) {
        //   toast.error(
        //     "Email already registered. Please use a different email."
        //   );
        // } else if (error.response?.status === 400) {
        //   toast.error(
        //     "Please wait before requesting another verification code."
        //   );
        // } else {
        //   toast.error("Failed to send verification code. Please try again.");
        // }
        // Enhanced error handling
        if (error.response?.data) {
          // Check for specific error messages from backend
          const errorMessage = error.response.data;

          if (typeof errorMessage === "string") {
            if (errorMessage.includes("EMAIL_ALREADY_REGISTERED")) {
              toast.error(
                "Email already registered. Please use a different email or login."
              );
            } else if (errorMessage.includes("OTP_COOLDOWN_ACTIVE")) {
              toast.error(
                "Please wait before requesting another verification code."
              );
            } else {
              toast.error(errorMessage);
            }
          } else if (errorMessage.message) {
            // Handle object response with message field
            toast.error(errorMessage.message);
          }
        } else if (error.response?.status === 409) {
          toast.error(
            "Email already registered. Please use a different email."
          );
        } else if (error.response?.status === 400) {
          toast.error(
            "Please wait before requesting another verification code."
          );
        } else if (error.message) {
          // Handle runtime errors from backend
          if (error.message.includes("EMAIL_ALREADY_REGISTERED")) {
            toast.error(
              "Email already registered. Please use a different email."
            );
          } else if (error.message.includes("OTP_COOLDOWN_ACTIVE")) {
            toast.error(
              "Please wait before requesting another verification code."
            );
          } else {
            toast.error(error.message);
          }
        } else {
          toast.error("Failed to send verification code. Please try again.");
        }
      } finally {
        setSubmitting(false);
        setIsSendingOtp(false);
      }
    },
  });

  const handleOtpVerification = async () => {
    if (!otp || otp.length !== 6) {
      toast.error("Please enter a valid 6-digit code");
      return;
    }

    try {
      setIsVerifying(true);
      await api.post("/verification/verify-otp", null, {
        params: {
          email: formData.email,
          code: otp,
        },
      });

      toast.success("Email verified successfully!");

      // Now submit the registration with verified email
      const filteredChildren = formData.children.filter(
        (child) => child.name.trim() !== ""
      );

      const submissionData = {
        ...formData,
        category: category,
        children: filteredChildren.length > 0 ? filteredChildren : undefined,
      };

      const response = await api.post(
        "/registration/membership",
        submissionData,
        {
          params: { emailVerificationToken: otp },
        }
      );

      if (response.status === 201) {
        toast.success("Registration submitted successfully!");
        navigate("/email-verified");
      }
    } catch (error) {
      console.error("Verification error:", error);
      toast.error(
        error.response?.data?.message ||
          "Verification failed. Please try again."
      );
    } finally {
      setIsVerifying(false);
    }
  };

  const handleResendOtp = async () => {
    try {
      // Check cooldown first
      if (cooldownSeconds > 0) {
        toast.error(
          `Please wait ${cooldownSeconds} seconds before requesting another code`
        );
        return;
      }

      setIsSendingOtp(true);
      await api.post("/verification/send-otp", null, {
        params: { email: formData.email },
      });

      // Start cooldown timer (60 seconds)
      startCooldownTimer(60);
      toast.success("New verification code sent!");
    } catch (error) {
      console.error("Error resending OTP:", error);

      if (error.response?.data?.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error("Failed to resend code. Please try again.");
      }
    } finally {
      setIsSendingOtp(false);
    }
  };

  // Helper functions for children fields
  const addChild = () => {
    // formik.setFieldValue("children", [
    //   ...formik.values.children,
    //   { name: "", dob: "", gender: "", honorary: false },
    // ]);
    if (
      formik.values.children.length === 0 ||
      formik.values.children[formik.values.children.length - 1].name.trim() !==
        ""
    ) {
      formik.setFieldValue("children", [
        ...formik.values.children,
        { name: "", dob: "", gender: "" },
      ]);
    }
  };

  const removeChild = (index) => {
    const updated = [...formik.values.children];
    updated.splice(index, 1);
    // formik.setFieldValue("children", updated);
    formik.setFieldValue("children", updated.length > 0 ? updated : undefined);
  };

  // Add these helper functions after removeChild function
  // Cooldown timer functions
  const startCooldownTimer = (seconds) => {
    setCooldownSeconds(seconds);

    const interval = setInterval(() => {
      setCooldownSeconds((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    setCooldownInterval(interval);
  };

  const clearCooldownTimer = () => {
    if (cooldownInterval) {
      clearInterval(cooldownInterval);
      setCooldownInterval(null);
    }
    setCooldownSeconds(0);
  };

  // Clean up interval on component unmount
  useEffect(() => {
    return () => {
      if (cooldownInterval) {
        clearInterval(cooldownInterval);
      }
    };
  }, [cooldownInterval]);

  // Max file size in bytes (2 MB )
  const MAX_FILE_SIZE = 5 * 1024 * 1024; // 2MB

  const handleFileChange = (fieldName) => async (event) => {
    const file = event.currentTarget.files[0]; // single file
    if (file) {
      if (!file.type.startsWith("image/")) {
        toast.error("Only image files are allowed");
        formik.setFieldError(fieldName, "Only image files are allowed");
        return;
      }

      if (file.size > MAX_FILE_SIZE) {
        toast.error(`File size must not exceed 2MB`);
        formik.setFieldError(fieldName, "File size must not exceed 2MB");
        return;
      }
      const url = await uploadToCloudinary(file);
      formik.setFieldValue(fieldName, url); // store Cloudinary URL
    }
  };

  return (
    <div className="bg-[#fffdf7] py-20 px-6 md:px-20">
      {/* <h1 className="text-4xl font-bold text-center text-black mb-12">
        Membership Registration
      </h1> */}

      <form onSubmit={formik.handleSubmit}>
        {showOtpModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg p-8 max-w-md w-full mx-4">
              <h3 className="text-2xl font-bold mb-4 text-center">
                Verify Your Email
              </h3>
              <p className="text-gray-600 mb-6 text-center">
                Enter the 6-digit verification code sent to{" "}
                <span className="font-semibold">{formData?.email}</span>
              </p>

              <div className="flex justify-center space-x-2 mb-6">
                {[...Array(6)].map((_, index) => (
                  <input
                    key={index}
                    type="text"
                    maxLength={1}
                    className="w-12 h-12 text-center text-2xl border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-lime-400"
                    value={otp[index] || ""}
                    onChange={(e) => {
                      const newOtp = otp.split("");
                      newOtp[index] = e.target.value;
                      setOtp(newOtp.join(""));

                      // Auto-focus next input
                      if (e.target.value && index < 5) {
                        document.getElementById(`otp-${index + 1}`).focus();
                      }
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Backspace" && !otp[index] && index > 0) {
                        document.getElementById(`otp-${index - 1}`).focus();
                      }
                    }}
                    id={`otp-${index}`}
                  />
                ))}
              </div>

              <div className="flex space-x-3">
                <button
                  type="button"
                  onClick={() => {
                    setShowOtpModal(false);
                    setOtp("");
                    clearCooldownTimer(); // Clear timer when modal closes
                  }}
                  className="flex-1 bg-gray-300 hover:bg-gray-400 text-gray-800 py-2 rounded-md font-semibold transition"
                  disabled={isVerifying}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  onClick={handleOtpVerification}
                  className="flex-1 bg-lime-400 hover:bg-black hover:text-white py-2 rounded-md font-semibold transition"
                  disabled={isVerifying || otp.length !== 6}
                >
                  {isVerifying ? "Verifying..." : "Verify & Register"}
                </button>
              </div>

              <div className="text-center mt-4">
                <button
                  type="button"
                  onClick={handleResendOtp}
                  className={`text-sm ${
                    cooldownSeconds > 0
                      ? "text-gray-400 cursor-not-allowed"
                      : "text-lime-600 hover:text-lime-800"
                  }`}
                  disabled={isSendingOtp || cooldownSeconds > 0}
                >
                  {isSendingOtp
                    ? "Sending..."
                    : cooldownSeconds > 0
                    ? `Resend available in ${cooldownSeconds}s`
                    : "Resend Code"}
                </button>
              </div>
            </div>
          </div>
        )}
        <div className="max-w-6xl mx-auto bg-[#fcfaec] rounded-xl p-6 md:p-10 space-y-10">
          {/* Section 1: Category & Type */}
          <section>
            <h2 className="text-2xl font-bold mb-4 text-black">
              Membership Category & Type
            </h2>
            <div className="grid md:grid-cols-2 gap-4">
              {/* <div>
                <select
                  className="p-3 bg-white rounded w-full outline-none"
                  name="category"
                  value={formik.values.category}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                >
                  <option disabled value="Select Category of Applicant">
                    Select Category of Applicant
                  </option>
                  <option>Serving Defence Officer</option>
                  <option>Retired Defence Officer</option>
                  <option>Serving Government Officer</option>
                  <option>Non Military</option>
                  <option>Corporate/Business</option>
                  <option>Foreigner/Diplomat</option>
                </select>
                {formik.touched.category && formik.errors.category ? (
                  <div className="text-red-500 text-sm mt-1">
                    {formik.errors.category}
                  </div>
                ) : null}
              </div> */}

              <div>
                <select
                  className="p-3 bg-white rounded w-full outline-none"
                  name="membershipType"
                  value={formik.values.membershipType}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                >
                  <option disabled value="Select Type of Membership">
                    Select Type of Membership
                  </option>
                  <option>Full Membership</option>
                  <option>Temporary Membership</option>
                  <option>Honorary Membership</option>
                  <option>Corporate Membership</option>
                </select>
                {formik.touched.membershipType &&
                formik.errors.membershipType ? (
                  <div className="text-red-500 text-sm mt-1">
                    {formik.errors.membershipType}
                  </div>
                ) : null}
              </div>
            </div>
          </section>

          {/* Section 2: Personal Info */}
          <section>
            <h2 className="text-2xl font-bold mb-4 text-black">
              Personal Information
            </h2>
            <div className="grid md:grid-cols-2 gap-4">
              <div>
                <input
                  type="text"
                  name="firstName"
                  placeholder="First Name"
                  className="p-3 rounded bg-white w-full outline-none"
                  value={formik.values.firstName}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.firstName && formik.errors.firstName ? (
                  <div className="text-red-500 text-sm mt-1">
                    {formik.errors.firstName}
                  </div>
                ) : null}
              </div>

              <div>
                <input
                  type="text"
                  name="lastName"
                  placeholder="Last Name"
                  className="p-3 rounded bg-white w-full outline-none"
                  value={formik.values.lastName}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.lastName && formik.errors.lastName ? (
                  <div className="text-red-500 text-sm mt-1">
                    {formik.errors.lastName}
                  </div>
                ) : null}
              </div>
              {/* <div>
                <input
                  type="text"
                  name="nameEnglish"
                  placeholder="Name"
                  className="p-3 rounded bg-white w-full"
                  value={formik.values.nameEnglish}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.nameEnglish && formik.errors.nameEnglish ? (
                  <div className="text-red-500 text-sm mt-1">
                    {formik.errors.nameEnglish}
                  </div>
                ) : null}
              </div> */}

              {/* <div>
                  <input
                    type="text"
                    name="nameBangla"
                    placeholder="Name (Bangla)"
                    className="p-3 rounded bg-white w-full"
                    value={formik.values.nameBangla}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.nameBangla && formik.errors.nameBangla ? (
                    <div className="text-red-500 text-sm mt-1">
                      {formik.errors.nameBangla}
                    </div>
                  ) : null}
                </div> */}

              <div>
                <input
                  type="text"
                  name="fatherOrHusbandName"
                  placeholder="Father's/Husband's Name"
                  className="p-3 rounded bg-white w-full"
                  value={formik.values.fatherOrHusbandName}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.fatherOrHusbandName &&
                formik.errors.fatherOrHusbandName ? (
                  <div className="text-red-500 text-sm mt-1">
                    {formik.errors.fatherOrHusbandName}
                  </div>
                ) : null}
              </div>

              <div>
                <input
                  type="text"
                  name="nationality"
                  placeholder="Nationality"
                  className="p-3 rounded bg-white w-full"
                  value={formik.values.nationality}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.nationality && formik.errors.nationality ? (
                  <div className="text-red-500 text-sm mt-1">
                    {formik.errors.nationality}
                  </div>
                ) : null}
              </div>

              <div>
                <input
                  type="text"
                  name="occupation"
                  placeholder="Occupation"
                  className="p-3 rounded bg-white w-full"
                  value={formik.values.occupation}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.occupation && formik.errors.occupation ? (
                  <div className="text-red-500 text-sm mt-1">
                    {formik.errors.occupation}
                  </div>
                ) : null}
              </div>

              <div>
                <input
                  type="text"
                  name="bloodGroup"
                  placeholder="Blood Group"
                  className="p-3 rounded bg-white w-full"
                  value={formik.values.bloodGroup}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.bloodGroup && formik.errors.bloodGroup ? (
                  <div className="text-red-500 text-sm mt-1">
                    {formik.errors.bloodGroup}
                  </div>
                ) : null}
              </div>

              <div>
                <input
                  type="tel"
                  name="mobile"
                  placeholder="Mobile Number"
                  className="p-3 rounded bg-white w-full"
                  value={formik.values.mobile}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.mobile && formik.errors.mobile ? (
                  <div className="text-red-500 text-sm mt-1">
                    {formik.errors.mobile}
                  </div>
                ) : null}
              </div>
            </div>

            <div className="mt-4">
              <textarea
                name="officialAddress"
                placeholder="Official Address"
                className="p-3 rounded bg-white w-full"
                value={formik.values.officialAddress}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.touched.officialAddress &&
              formik.errors.officialAddress ? (
                <div className="text-red-500 text-sm mt-1">
                  {formik.errors.officialAddress}
                </div>
              ) : null}
            </div>

            <div className="mt-4">
              <textarea
                name="presentAddress"
                placeholder="Present Address"
                className="p-3 rounded bg-white w-full"
                value={formik.values.presentAddress}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.touched.presentAddress && formik.errors.presentAddress ? (
                <div className="text-red-500 text-sm mt-1">
                  {formik.errors.presentAddress}
                </div>
              ) : null}
            </div>

            <div className="mt-4">
              <textarea
                name="permanentAddress"
                placeholder="Permanent Address"
                className="p-3 rounded bg-white w-full"
                value={formik.values.permanentAddress}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.touched.permanentAddress &&
              formik.errors.permanentAddress ? (
                <div className="text-red-500 text-sm mt-1">
                  {formik.errors.permanentAddress}
                </div>
              ) : null}
            </div>
          </section>

          {/* Section 3: Income */}
          <section>
            <h2 className="text-2xl font-bold mb-4 text-black">
              Income & Tax Details
            </h2>
            <div>
              <input
                type="text"
                name="monthlyIncome"
                placeholder="Monthly Income"
                className="p-3 rounded bg-white w-full mb-4"
                value={formik.values.monthlyIncome}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.touched.monthlyIncome && formik.errors.monthlyIncome ? (
                <div className="text-red-500 text-sm mt-1">
                  {formik.errors.monthlyIncome}
                </div>
              ) : null}
            </div>
            <label className="block mb-2 font-semibold text-black">
              Upload Income Tax Return (image)
            </label>
            <input
              type="file"
              accept="image/*"
              name="incomeTaxReturn"
              className="block w-full bg-white p-2 rounded"
              onChange={handleFileChange("incomeTaxReturn")}
              onBlur={formik.handleBlur}
            />
            {formik.touched.incomeTaxReturn && formik.errors.incomeTaxReturn ? (
              <div className="text-red-500 text-sm mt-1">
                {formik.errors.incomeTaxReturn}
              </div>
            ) : null}
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4 text-black">
              Identity Documents
            </h2>
            <>
              <div className="mb-6">
                <h3 className="text-lg font-semibold mb-3">
                  National ID Details (Required)
                </h3>
                <div className="grid md:grid-cols-2 gap-4">
                  <div>
                    <input
                      type="text"
                      name="nationalId"
                      placeholder="National ID Number"
                      className="p-3 rounded bg-white w-full"
                      value={formik.values.nationalId}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.nationalId && formik.errors.nationalId ? (
                      <div className="text-red-500 text-sm mt-1">
                        {formik.errors.nationalId}
                      </div>
                    ) : null}
                  </div>

                  <div>
                    <input
                      type="text"
                      name="nidName"
                      placeholder="Name as in NID"
                      className="p-3 rounded bg-white w-full"
                      value={formik.values.nidName}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.nidName && formik.errors.nidName ? (
                      <div className="text-red-500 text-sm mt-1">
                        {formik.errors.nidName}
                      </div>
                    ) : null}
                  </div>

                  <div>
                    <input
                      type="text"
                      name="nidFathersName"
                      placeholder="Father's Name (from NID)"
                      className="p-3 rounded bg-white w-full"
                      value={formik.values.nidFathersName}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.nidFathersName &&
                    formik.errors.nidFathersName ? (
                      <div className="text-red-500 text-sm mt-1">
                        {formik.errors.nidFathersName}
                      </div>
                    ) : null}
                  </div>

                  <div>
                    <input
                      type="text"
                      name="nidMothersName"
                      placeholder="Mother's Name (from NID)"
                      className="p-3 rounded bg-white w-full"
                      value={formik.values.nidMothersName}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.nidMothersName &&
                    formik.errors.nidMothersName ? (
                      <div className="text-red-500 text-sm mt-1">
                        {formik.errors.nidMothersName}
                      </div>
                    ) : null}
                  </div>

                  <div>
                    <label className="text-gray-400 pl-2" htmlFor="">
                      Date Of Birth
                    </label>
                    <input
                      type="date"
                      name="nidDob"
                      placeholder="Date of Birth (from NID)"
                      className="p-3 rounded bg-white w-full"
                      value={formik.values.nidDob}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.nidDob && formik.errors.nidDob ? (
                      <div className="text-red-500 text-sm mt-1">
                        {formik.errors.nidDob}
                      </div>
                    ) : null}
                  </div>

                  <div>
                    <label className="block mb-2 font-semibold text-black">
                      Upload NID (image)
                    </label>
                    <input
                      type="file"
                      accept="image/*"
                      name="nidCopy"
                      className="block w-full bg-white p-2 rounded"
                      onChange={handleFileChange("nidCopy")}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.nidCopy && formik.errors.nidCopy ? (
                      <div className="text-red-500 text-sm mt-1">
                        {formik.errors.nidCopy}
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>

              {/* <div className="mt-6">
                  <h3 className="text-lg font-semibold mb-3">
                    Passport Details (Optional)
                  </h3>
                  <div className="grid md:grid-cols-2 gap-4">
                    <div>
                      <input
                        type="text"
                        name="passportNumber"
                        placeholder="Passport Number"
                        className="p-3 rounded bg-white w-full"
                        value={formik.values.passportNumber}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched.passportNumber &&
                      formik.errors.passportNumber ? (
                        <div className="text-red-500 text-sm mt-1">
                          {formik.errors.passportNumber}
                        </div>
                      ) : null}
                    </div>

                    <div>
                      <input
                        type="text"
                        name="passportType"
                        placeholder="Passport Type"
                        className="p-3 rounded bg-white w-full"
                        value={formik.values.passportType}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched.passportType &&
                      formik.errors.passportType ? (
                        <div className="text-red-500 text-sm mt-1">
                          {formik.errors.passportType}
                        </div>
                      ) : null}
                    </div>

                    <div>
                      <input
                        type="text"
                        name="passportPlaceOfIssue"
                        placeholder="Place of Issue"
                        className="p-3 rounded bg-white w-full"
                        value={formik.values.passportPlaceOfIssue}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched.passportPlaceOfIssue &&
                      formik.errors.passportPlaceOfIssue ? (
                        <div className="text-red-500 text-sm mt-1">
                          {formik.errors.passportPlaceOfIssue}
                        </div>
                      ) : null}
                    </div>

                    <div>
                      <label className="text-gray-400 pl-2" htmlFor="">
                        Date Of Expiry
                      </label>
                      <input
                        type="date"
                        name="passportExpiry"
                        placeholder="Date of Expiry"
                        className="p-3 rounded bg-white w-full"
                        value={formik.values.passportExpiry}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched.passportExpiry &&
                      formik.errors.passportExpiry ? (
                        <div className="text-red-500 text-sm mt-1">
                          {formik.errors.passportExpiry}
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div> */}
            </>
          </section>

          {/* Section 5: Family */}
          <section>
            <h2 className="text-2xl font-bold mb-4 text-black">
              Family Details
            </h2>
            <h4 className="text-lg font-semibold text-black mt-4 mb-2">
              Spouse (if any)
            </h4>
            <div>
              <input
                type="text"
                name="spouseName"
                placeholder="Spouse Name"
                className="p-3 rounded bg-white w-full mb-4"
                value={formik.values.spouseName}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.touched.spouseName && formik.errors.spouseName ? (
                <div className="text-red-500 text-sm mt-1">
                  {formik.errors.spouseName}
                </div>
              ) : null}
            </div>

            <div>
              <input
                type="text"
                name="spouseOccupation"
                placeholder="Spouse Occupation"
                className="p-3 rounded bg-white w-full mb-4"
                value={formik.values.spouseOccupation}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.touched.spouseOccupation &&
              formik.errors.spouseOccupation ? (
                <div className="text-red-500 text-sm mt-1">
                  {formik.errors.spouseOccupation}
                </div>
              ) : null}
            </div>

            <div>
              <input
                type="text"
                name="spouseAddress"
                placeholder="Spouse Address"
                className="p-3 rounded bg-white w-full mb-4"
                value={formik.values.spouseAddress}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.touched.spouseAddress && formik.errors.spouseAddress ? (
                <div className="text-red-500 text-sm mt-1">
                  {formik.errors.spouseAddress}
                </div>
              ) : null}
            </div>

            <h4 className="text-lg font-semibold text-black mt-4 mb-2">
              Children/Dependants below 21 (if any)
            </h4>
            {formik.values.children &&
              formik.values.children.length > 0 &&
              formik.values.children.map((child, i) => (
                <div
                  key={i}
                  className="grid grid-cols-2 lg:grid-cols-2 gap-3 mb-2 items-center"
                >
                  <div className="pt-6">
                    <input
                      type="text"
                      placeholder="Name"
                      className="p-2 rounded bg-white w-full"
                      value={child.name}
                      onChange={(e) => {
                        const updatedChildren = [...formik.values.children];
                        updatedChildren[i].name = e.target.value;
                        formik.setFieldValue("children", updatedChildren);
                      }}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.children?.[i]?.name &&
                    formik.errors.children?.[i]?.name ? (
                      <div className="text-red-500 text-sm mt-1">
                        {formik.errors.children[i].name}
                      </div>
                    ) : null}
                  </div>

                  <div>
                    <label className="text-gray-400 pl-2" htmlFor="">
                      Date Of Birth
                    </label>
                    <input
                      type="date"
                      placeholder="Date of Birth"
                      className="p-2 rounded bg-white w-full"
                      value={child.dob}
                      onChange={(e) => {
                        const updatedChildren = [...formik.values.children];
                        updatedChildren[i].dob = e.target.value;
                        formik.setFieldValue("children", updatedChildren);
                      }}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.children?.[i]?.dob &&
                    formik.errors.children?.[i]?.dob ? (
                      <div className="text-red-500 text-sm mt-1">
                        {formik.errors.children[i].dob}
                      </div>
                    ) : null}
                  </div>

                  <div className="pt-6">
                    <input
                      type="text"
                      placeholder="Relationship"
                      className="p-2 rounded bg-white w-full"
                      value={child.gender}
                      onChange={(e) => {
                        const updatedChildren = [...formik.values.children];
                        updatedChildren[i].gender = e.target.value;
                        formik.setFieldValue("children", updatedChildren);
                      }}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.children?.[i]?.gender &&
                    formik.errors.children?.[i]?.gender ? (
                      <div className="text-red-500 text-sm mt-1">
                        {formik.errors.children[i].gender}
                      </div>
                    ) : null}
                  </div>

                  <div className="">
                    {/* <label className="text-gray-400 pl-2" htmlFor="">
                        Honorary?
                      </label>
                      <select
                        className="p-2 rounded bg-white w-full"
                        value={child.honorary ? "Yes" : "No"}
                        onChange={(e) => {
                          const updatedChildren = [...formik.values.children];
                          updatedChildren[i].honorary = e.target.value === "Yes";
                          formik.setFieldValue("children", updatedChildren);
                        }}
                        onBlur={formik.handleBlur}
                      >
                        <option>Yes</option>
                        <option>No</option>
                      </select> */}
                    {/* {formik.touched.children?.[i]?.honorary &&
                    formik.errors.children?.[i]?.honorary ? (
                      <div className="text-red-500 text-sm mt-1">
                        {formik.errors.children[i].honorary}
                      </div>
                    ) : null} */}

                    {/* Delete button */}
                    {formik.values.children.length > 1 && (
                      <button
                        type="button"
                        onClick={() => removeChild(i)}
                        className="text-red-500 text-md"
                        title="Remove Child"
                      >
                        ✖
                      </button>
                    )}
                  </div>
                </div>
              ))}
            <button
              type="button"
              onClick={addChild}
              className="text-sm text-green-600 underline mt-2"
            >
              + Add {formik.values.children.length >= 1 && "Another"} Child
            </button>
          </section>

          {/* Section 6: Other Details */}
          <section>
            <h2 className="text-2xl font-bold mb-4 text-black">
              Golf Club Details (Optional)
            </h2>
            <div>
              <input
                type="text"
                name="golfClubMembership"
                placeholder="Membership of any Golf Club (if any)"
                className="p-3 rounded bg-white w-full mb-4"
                value={formik.values.golfClubMembership}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.touched.golfClubMembership &&
              formik.errors.golfClubMembership ? (
                <div className="text-red-500 text-sm mt-1">
                  {formik.errors.golfClubMembership}
                </div>
              ) : null}
            </div>

            <div>
              <input
                type="text"
                name="officialHandicap"
                placeholder="Official Handicap (if any)"
                className="p-3 rounded bg-white w-full"
                value={formik.values.officialHandicap}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.touched.officialHandicap &&
              formik.errors.officialHandicap ? (
                <div className="text-red-500 text-sm mt-1">
                  {formik.errors.officialHandicap}
                </div>
              ) : null}
            </div>
          </section>

          {/* Section 7: File Uploads */}
          <section>
            <h2 className="text-2xl font-bold mb-4 text-black">Photos</h2>
            <label className="block mb-2">
              Upload Your Photo (passport size)
            </label>
            <input
              type="file"
              name="photo"
              accept="image/*"
              // multiple
              className="mb-4 block w-full bg-white p-2 rounded"
              // onChange={handleMultipleFilesChange("photo")}
              onChange={handleFileChange("photo")}
              onBlur={formik.handleBlur}
            />
            {formik.touched.photo && formik.errors.photo ? (
              <div className="text-red-500 text-sm mt-1">
                {formik.errors.photo}
              </div>
            ) : null}

            {/* <label className="block mb-2">
              Upload NID, Passport, TIN, Employer Certificate, Tax Certificate
              (image files)
            </label>
            <input
              type="file"
              accept="image/*"
              name="documents"
              multiple
              className="block w-full bg-white p-2 rounded"
              onChange={handleMultipleFilesChange("documents")}
              onBlur={formik.handleBlur}
            />
            {formik.touched.documents && formik.errors.documents ? (
              <div className="text-red-500 text-sm mt-1">
                {formik.errors.documents}
              </div>
            ) : null} */}
          </section>

          {/* Section 8: Reference / Proposer */}
          {!["Serving Defence Officer", "Retired Defence Officer"].includes(
            formik.values.category
          ) && (
            <section>
              <h2 className="text-2xl font-bold mb-4 text-black">
                Reference (For Civilians Only)
              </h2>
              <div>
                <input
                  type="text"
                  name="proposerName"
                  placeholder="Proposer Name"
                  className="p-3 rounded bg-white w-full mb-4"
                  value={formik.values.proposerName}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.proposerName && formik.errors.proposerName ? (
                  <div className="text-red-500 text-sm mt-1">
                    {formik.errors.proposerName}
                  </div>
                ) : null}
              </div>

              <div>
                <input
                  type="text"
                  name="proposerMembership"
                  placeholder="Proposer Membership No"
                  className="p-3 rounded bg-white w-full mb-4"
                  value={formik.values.proposerMembership}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.proposerMembership &&
                formik.errors.proposerMembership ? (
                  <div className="text-red-500 text-sm mt-1">
                    {formik.errors.proposerMembership}
                  </div>
                ) : null}
              </div>

              <div>
                <input
                  type="text"
                  name="proposerClubName"
                  placeholder="Proposer Club Name"
                  className="p-3 rounded bg-white w-full mb-4"
                  value={formik.values.proposerClubName}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.proposerClubName &&
                formik.errors.proposerClubName ? (
                  <div className="text-red-500 text-sm mt-1">
                    {formik.errors.proposerClubName}
                  </div>
                ) : null}
              </div>

              <label className="block mb-2 font-semibold text-black">
                Upload Proposer's Signature (image)
              </label>
              <input
                type="file"
                accept="image/*"
                name="proposerSignature"
                className="block w-full bg-white p-2 rounded"
                onChange={handleFileChange("proposerSignature")}
                onBlur={formik.handleBlur}
              />
              {formik.touched.proposerSignature &&
              formik.errors.proposerSignature ? (
                <div className="text-red-500 text-sm mt-1">
                  {formik.errors.proposerSignature}
                </div>
              ) : null}
            </section>
          )}

          {/* Section 9: Account Registration */}
          <section>
            <h2 className="text-2xl font-bold mb-4 text-black">
              Create Your Account
            </h2>
            <div className="grid md:grid-cols-2 gap-4">
              <div>
                <input
                  type="email"
                  name="email"
                  placeholder="Email Address"
                  className="p-3 rounded bg-white w-full outline-none"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.email && formik.errors.email ? (
                  <div className="text-red-500 text-sm mt-1">
                    {formik.errors.email}
                  </div>
                ) : null}
              </div>

              {/* <div>
                <input
                  type="password"
                  name="password"
                  placeholder="Password"
                  className="p-3 rounded bg-white w-full outline-none"
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.password && formik.errors.password ? (
                  <div className="text-red-500 text-sm mt-1">
                    {formik.errors.password}
                  </div>
                ) : null}
              </div>

              <div>
                <input
                  type="password"
                  name="confirmPassword"
                  placeholder="Confirm Password"
                  className="p-3 rounded bg-white w-full outline-none"
                  value={formik.values.confirmPassword}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.confirmPassword &&
                formik.errors.confirmPassword ? (
                  <div className="text-red-500 text-sm mt-1">
                    {formik.errors.confirmPassword}
                  </div>
                ) : null}
              </div> */}
            </div>
          </section>

          {/* Submit */}
          <div>
            {/* <button
              type="submit"
              className="bg-lime-400 hover:bg-black hover:text-white w-full py-3 rounded-full font-bold text-black transition"
              disabled={formik.isSubmitting}
            >
              {formik.isSubmitting ? "Submitting..." : "Submit Registration"}
            </button> */}
            {/* <button
              type="submit"
              className="bg-lime-400 hover:bg-black hover:text-white w-full py-3 rounded-full font-bold text-black transition"
              disabled={formik.isSubmitting}
            >
              {formik.isSubmitting ? (
                <span className="flex items-center justify-center">
                  <svg
                    className="animate-spin -ml-1 mr-3 h-5 w-5 text-black"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                  Processing...
                </span>
              ) : (
                "REGISTER"
              )}
            </button> */}
            <button
              type="submit"
              className="bg-lime-400 hover:bg-black hover:text-white w-full py-3 rounded-full font-bold text-black transition"
              disabled={formik.isSubmitting || isSendingOtp}
            >
              {formik.isSubmitting || isSendingOtp ? (
                <span className="flex items-center justify-center">
                  <svg
                    className="animate-spin -ml-1 mr-3 h-5 w-5 text-black"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                  {isSendingOtp ? "Sending Code..." : "Processing..."}
                </span>
              ) : (
                "SEND VERIFICATION CODE"
              )}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default CivilianForm;
